import React, { useState, useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { formatCurrency, setLocaleFromCountry } from 'supporticon/utils/numbers'
import { fetchDonation, deserializeDonation } from 'supporticon/api/donations'
import { fetchPage, deserializePage } from 'supporticon/api/pages'
import { selectLocalisation } from '../../../store/site'
import { withRouter } from 'react-router'
import dayjs from 'dayjs'
import numbro from 'numbro'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Icon from 'constructicon/icon'
import LeaderboardItem from 'constructicon/leaderboard-item'
import Loading from '../../ui/Loading'
import Section from '../../ui/Section'

const DonationDetail = ({
  alignment,
  backgroundImage,
  background,
  classNames,
  copy,
  country,
  foreground,
  layout,
  router,
  size,
  spacing,
  title
}) => {
  const [status, setStatus] = useState('fetching')
  const [donation, setDonation] = useState(null)
  const [pageStatus, setPageStatus] = useState('fetching')
  const [page, setPage] = useState(null)
  const donationId = router.location.query['donation-id']

  useEffect(() => {
    if (donationId) {
      fetchDonation(donationId)
        .then(donation => deserializeDonation(donation))
        .then(donation => setDonation(donation))
        .then(() => setStatus('fetched'))
        .catch(error => {
          setStatus('failed')
          return Promise.reject(error)
        })
    }
  }, [donationId])

  useEffect(() => {
    if (donation && donation.page) {
      fetchPage(donation.page)
        .then(page => deserializePage(page))
        .then(page => setPage(page))
        .then(() => setPageStatus('fetched'))
        .catch(error => {
          setPageStatus('failed')
          return Promise.reject(error)
        })
    }
  }, [donation])

  if (!donationId) return null

  const renderAmount = (amount, currency) =>
    formatCurrency({
      amount,
      currencyCode: currency,
      locale: setLocaleFromCountry(country)
    })

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>
      <Content
        layout={layout}
        title={title}>
        {status === 'fetching' && <Loading />}
        {status === 'failed' && <Error />}
        {status === 'fetched' && (
          <div className={classNames.root}>
            <div className={classNames.detail}>
              {donation.amount
                ? `${donation.name} donated ${renderAmount(donation.amount, donation.currency)}`
                : `${donation.name} made a donation`}
            </div>
            <div className={classNames.meta}>
              <div>{dayjs(donation.createdAt).fromNow()}</div>
              {!!donation.giftAidAmount && (
                <div>{`${renderAmount(donation.giftAidAmount, donation.currency)} Gift Aid`}</div>
              )}
            </div>
            {donation.message && (
              <div className={classNames.message}>
                {donation.message}
              </div>
            )}
            {donation.status === 'Pending' && (
              <div className={classNames.status}>
                <Icon name='warning' />
                <span>Please note this donation is still processing</span>
              </div>
            )}
            {page && (
              <>
                <div className={classNames.label}>Donation made to</div>
                {pageStatus === 'fetched' && (
                  <div className={classNames.page}>
                    <LeaderboardItem
                      amount={numbro(page.raised).formatCurrency('0,0.[00]')}
                      background='light'
                      borderWidth={1}
                      foreground='dark'
                      image={page.image}
                      href={page.url}
                      spacing={0.666}
                      subtitle={page.charity.name}
                      title={page.name}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </Content>
    </Section>
  )
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withRouter
)(DonationDetail)
